/** Detecta tipo de anexo para exibição no simulador (estilo WhatsApp). */
export function extractFileNameFromUrl(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  try {
    const pathname = new URL(raw).pathname;
    const base = pathname.split("/").pop() || "";
    return decodeURIComponent(base.split("?")[0]) || "";
  } catch {
    const parts = raw.split("/");
    return decodeURIComponent(parts[parts.length - 1]?.split("?")[0] || "");
  }
}

export function resolveSimulatorAttachmentKind({ messageType, contentType, url, fileName } = {}) {
  const ct = String(contentType || "").toLowerCase();
  const name = String(fileName || extractFileNameFromUrl(url) || url || "").toLowerCase();
  const ext = name.includes(".") ? name.split(".").pop() : "";

  if (messageType === "image" || ct.startsWith("image/") || /^(png|jpe?g|gif|webp|bmp|svg|heic|heif)$/.test(ext)) {
    return "image";
  }
  if (messageType === "video" || ct.startsWith("video/") || /^(mp4|webm|mov|avi|mkv|m4v)$/.test(ext)) {
    return "video";
  }
  if (messageType === "audio" || ct.startsWith("audio/") || /^(mp3|ogg|wav|m4a|aac|opus|flac)$/.test(ext)) {
    return "audio";
  }
  if (ct === "application/pdf" || ext === "pdf") return "pdf";
  if (
    ct.includes("spreadsheet") ||
    ct.includes("excel") ||
    ct === "text/csv" ||
    /^(xlsx?|csv|ods|numbers)$/.test(ext)
  ) {
    return "spreadsheet";
  }
  if (
    ct.includes("word") ||
    ct.includes("msword") ||
    ct.includes("officedocument.wordprocessing") ||
    /^(docx?|odt|rtf)$/.test(ext)
  ) {
    return "document";
  }
  if (
    ct.includes("zip") ||
    ct.includes("rar") ||
    ct.includes("7z") ||
    ct.includes("gzip") ||
    /^(zip|rar|7z|tar|gz|bz2)$/.test(ext)
  ) {
    return "archive";
  }
  if (ct.startsWith("text/") || /^(txt|md|log|json|xml|html?)$/.test(ext)) return "text";
  return "file";
}

export const SIMULATOR_ATTACHMENT_LABELS = {
  image: "Imagem",
  video: "Vídeo",
  audio: "Áudio",
  pdf: "PDF",
  spreadsheet: "Planilha",
  document: "Documento",
  archive: "Arquivo compactado",
  text: "Arquivo de texto",
  file: "Arquivo",
};
